import Header from "@/types/app/header";

export default class NewsHeader {
  public static header: Header[] = [
    {
      text: "Date",
      align: "start",
      sortable: true,
      value: "dtNew",
      class: "item-table-header item-table-header-updateDateTime",
      width: "80px"
    },  
    {
      text: "Title",
      align: "start",
      sortable: true,
      value: "title",
      class: "item-table-header item-table-header-name",
      width: ""
    },  
    {
      text: "Description",
      align: "start",
      sortable: true,
      value: "description",
      class: "item-table-header item-table-header-name",
      width: "380px"
    },
    {
      text: "Published",
      align: "start",
      sortable: true,
      value: "published",
      class: "item-table-header item-table-header-description",
      width: "80px"
    },
    {
      text: "",
      align: "right",
      value: "actions",
      sortable: false,
      class: null,
      width: "80px"
    }
  ];
}
